import axios from 'axios';

const INITIAL_STATE = {
  isLoading: false,
  allPageIcons: [],
  iconTypes: [],
};

const state = () => ({ ...INITIAL_STATE });

let getAllPageIconsRequest = null;

const mutations = {
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setAllPageIcons(state, allPageIcons) {
    state.allPageIcons = allPageIcons;
  },
  setIconTypes(state, iconTypes) {
    state.iconTypes = iconTypes;
  },
  // Drops the session cache below so the next getAllPageIcons re-pulls from the
  // API. The icon list is filtered per-member server-side (pastoral access AND
  // course entitlements), so it goes stale the moment that access changes —
  // see the courses module's fetchCourseAccess.
  invalidateAllPageIcons(state) {
    state.allPageIcons = [];
    state.iconTypes = [];
  },
};

const actions = {
  async getAllPageIcons({ state, commit, dispatch, rootState }, options = {}) {
    const force = options?.force === true;

    if (!force && state.allPageIcons?.length > 0) {
      return state.allPageIcons;
    }

    if (getAllPageIconsRequest) {
      return getAllPageIconsRequest;
    }

    commit('setIsLoading', true);

    getAllPageIconsRequest = (async () => {
      try {
        const accessToken = rootState.user.token;
        const { status, data } = await axios.get(
          process.env.VUE_APP_API_URL + '/allpage/all-page-icons',
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (status !== 200) throw new Error('Failed in getting all page icons');

        // Group icons into their sections (iconType), sorted by section priority.
        // Icons with no section are skipped for display but kept in allPageIcons,
        // which the Absolutely access check scans.
        const sections = new Map();
        for (const icon of data) {
          const type = icon?.iconType;
          if (!type) continue;
          if (!sections.has(type.id)) sections.set(type.id, { ...type, icons: [] });
          sections.get(type.id).icons.push(icon);
        }
        const iconTypes = [...sections.values()].sort((a, b) => (a.priority > b.priority ? 1 : -1));

        commit('setIconTypes', iconTypes);
        commit('setAllPageIcons', data);
        return data;
      } catch (e) {
        dispatch('toast/error', 'Failed to get all page icons.', {
          root: true,
        });
        return null;
      } finally {
        commit('setIsLoading', false);
        getAllPageIconsRequest = null;
      }
    })();

    return getAllPageIconsRequest;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
